export default __webpack_public_path__ + "static/media/DB_9.37edffad.png";